import { EffectFade, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, BrowserEvents } from './constants';

Swiper.use([EffectFade, Navigation, Pagination]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Sections ----------

		$('.quotes-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: 1000,
					loop: true,
					observer: true,
					autoHeight: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		$('.images-slider-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: 1000,
					observer: true,
					slidesPerView: 'auto',
					preventInteractionOnTransition: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: 'progressbar',
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		$('.single-wine-section .column-slideshow').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: 1000,
					observer: true,
					slidesPerView: 'auto',
					preventInteractionOnTransition: true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: 'progressbar',
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});

}(jQuery));
